import { defineStore } from 'pinia';

import {
  AccountDetailResponse,
  AccountRepository,
  AcquirerResponse,
  CompanyResponse,
  GiftIssuerAutocompleteResponse,
  IssuerResponse,
  ShopResponse,
  TenantResponse,
  WalletServiceResponse,
} from '@/repositories/generated';
import { AccountEditForm } from '@/validations';

type TAccountState = {
  form: AccountEditForm | undefined;
  initData: AccountDetailResponse | undefined;
  selectedAcquirerName: AcquirerResponse | undefined;
  selectedIssuerName: IssuerResponse | undefined;
  selectedWalletServiceName: WalletServiceResponse | undefined;
  selectedGiftIssuerName: GiftIssuerAutocompleteResponse | undefined;
  selectedCompanyName: CompanyResponse | undefined;
  selectedShopName: ShopResponse | undefined;
  selectedTenantName: TenantResponse | undefined;
};

export const useEditAccountStore = defineStore('editAccount', {
  state: (): TAccountState => ({
    form: undefined,
    initData: undefined,
    selectedAcquirerName: undefined,
    selectedIssuerName: undefined,
    selectedWalletServiceName: undefined,
    selectedGiftIssuerName: undefined,
    selectedCompanyName: undefined,
    selectedShopName: undefined,
    selectedTenantName: undefined,
  }),
  actions: {
    async editAccount() {
      const { form } = this;

      if (!form || !this.initData) return;

      await AccountRepository.edit({
        id: this.initData.id ?? '',
        requestBody: {
          ...form,
          acquirerId: form.acquirerId,
          companyId: form.companyId,
          email: form.email,
          valueIssuerId: form.valueIssuerId,
          loginId: form.loginId,
          name: form.name,
          remarks: form.remarks,
          role: form.role,
          shopId: form.shopId,
          walletServiceId: form.walletServiceId,
          // BE 仕様: giftIssuerId は number 型（AccountRegisterForm と同様）
          // FE フォームは string（GiftIssuerAutocompleteResponse.id）で保持しているため変換
          giftIssuerId: form.giftIssuerId ? Number(form.giftIssuerId) : undefined,
          lastUpdatedAt: this.initData.updatedAt ?? '',
          tenantId: form.tenantId,
        },
      });
    },
    setForm(form: AccountEditForm) {
      const createFrom = (_form: AccountEditForm) => ({
        ..._form,
      });
      this.form = createFrom(form);
    },
    async setInitData(id: string) {
      this.$reset();

      const response = await AccountRepository.detail({ id });
      this.initData = response;
    },
    setUiForm(form: AccountEditForm) {
      const createForm = (_form: AccountEditForm) => ({
        ..._form,
      });
      this.form = createForm(form);
    },
    $resetForm() {
      this.form = undefined;
    },
  },
});
